import { ITableConfig } from "@/features/port-congestion/congestion-container-list";
import { StoreGeneric } from "pinia";

export type QueryParams = Record<string, any>;

export enum Direction {
  IMPORT = "IMPORT",
  EXPORT = "EXPORT"
}

export enum ScreenBreakpoint {
  MOBILE = "mobile",
  TABLET_PORTRAIT = "tablet-portrait",
  TABLET_LANDSCAPE = "tablet-landscape",
  DESKTOP = "desktop",
  WIDE_DESKTOP = "wide-desktop"
}

export enum FIT {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small"
}

export type Position = {
  longitude: number;
  latitude: number;
};

export type Location = {
  countryName?: string;
  countryCode?: string;
  cityName?: string;
  cityCode?: string;
  locationCode: string;
  position?: Position;
};

export type Port = {
  name: string;
  code: string;
  location?: Location;
};

export type Terminal = {
  name: string;
  code: string;
  location: {
    countryName: string;
    countryCode: string;
    cityName: string;
    cityCode: string;
    locationCode: string;
    position: {
      longitude: number;
      latitude: number;
    };
  };
};

export type FormattedDate = {
  formattedDate: string;
  timeZoneName: string;
};

export type Pagination = {
  pageNumber: number;
  pageSize?: number;
  totalCount?: number;
};

export enum SortDirection {
  ASC = "asc",
  DESC = "desc"
}

export type SortConfig = {
  field: string;
  direction: SortDirection;
};

export type ApiStatus = {
  loadingIndicator: boolean;
  errorIndicator?: boolean;
  errorMessage?: string;
};

export enum TransportMode {
  AIR = "AIR",
  OCEAN = "OCEAN",
  ROAD = "ROAD",
  RAIL = "RAIL",
  INLAND_WATERS = "INLANDWATERS",
  UNKNOWN = "UNKNOWN"
}

export type EventDetails = {
  id: string;
  value?: any;
};

export type Emits = (e: "onEvent", event: Event) => void;

export enum EventType {
  FOCUS,
  LEAVE,
  CLICK
}
export type Event = {
  eventType: EventType;
  data: EventDetails;
};

export type PageChangeEvent = {
  detail: number;
};

export type MapAndTablePageStore = StoreGeneric & {
  // TODO: will add more properties while expanding the store complexity
  tableConfig: ITableConfig;
};

export enum Status {
  SUCCESSFUL = "SUCCESSFUL",
  FAILED = "FAILED",
  IN_PROGRESS = "IN_PROGRESS",
  QUEUED = "QUEUED"
}

export enum ContainerType {
  DRY = "dry",
  REEFER = "reefer"
}

export enum DateTypeOptions {
  ETA = "ETA",
  ATA = "ATA",
  ETD = "ETD",
  ATD = "ATD"
}

export enum DownloadActionTypes {
  RETRY = "RETRY",
  DOWNLOAD = "DOWNLOAD",
  DELETE = "DELETE"
}

export enum ProductType {
  SHIPMENT = "shipment",
  DnD = "dnd",
  PORT_CONGESTION = "portCongestion",
  AIR_SHIPMENT = "airShipment",
  EMISSION = "Emission",
  RISK_MANAGEMENT = "mrm",
  CARRIER_PERFORMANCE = "carrierPerformance",
  BOOKING_VOLUME_PERFORMANCE = "bookingVolumePerformance"
}

export enum NotificationType {
  DOWNLOAD_READY = "DOWNLOAD_READY",
  DOWNLOAD_FAILED = "DOWNLOAD_FAILED",
  UPLOAD_READY = "UPLOAD_READY",
  UPLOAD_PROCESSING = "UPLOAD_PROCESSING",
  UPLOAD_FAILED = "UPLOAD_FAILED"
}

export enum ReportModule {
  DOWNLOAD = "download",
  UPLOAD = "upload"
}

export type AggregationGranularity = "WEEKLY" | "MONTHLY" | "QUARTERLY" | "YEARLY";
